import { useEffect } from "react";

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      !("serviceWorker" in navigator) ||
      process.env.NODE_ENV !== "production"
    ) {
      return;
    }

    const handleLoad = () => {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .catch((_error) => {
          // biome-ignore lint/suspicious/noConsole: debugging purposes
          console.error("Service worker registration failed", _error);
        });
    };

    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return null;
}
